import React, { useState, useEffect, useContext } from 'react';
import './Collection.css';
import Item from '../Item/Item';
import { useSearchBar } from '../../Context/SearchBarContext';
import { useNav } from '../../Context/NavContext';
import { useProduct } from '../../Context/ProductContext';
import { UrlContext } from '../../Context/UrlContext';

function Collection() {

         const { apiBaseUrl } = useContext(UrlContext);

  const [selectedTypes, setSelectedTypes] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const { isSearchOpen } = useSearchBar(); // In case you want to use this later
  const { setProductDetails } = useProduct();
  const { setActiveItem } = useNav();

  console.log(products)

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`${apiBaseUrl}/products`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) throw new Error('Failed to fetch products');

        const data = await response.json();

        const productsWithImages = data.map(product => ({
          ...product,
          image: product.image ? product.image : null,
          sizes: Array.isArray(product.sizes) ? product.sizes : []
        }));

        setProducts(productsWithImages);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching products:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handleTypeChange = (e) => {
    const { value, checked } = e.target;
    setSelectedTypes(prev => checked ? [...prev, value] : prev.filter(type => type !== value));
  };

  const productTypes = [...new Set(products.map(product => product.product_type))].filter(Boolean);
  console.log(products)

  const filteredItems = products.filter((item) => {
    const matchesSearch = !searchQuery || (item.name || '').toLowerCase().includes(searchQuery.toLowerCase());
    const matchesType = selectedTypes.length === 0 || selectedTypes.includes(item.product_type);
    return matchesSearch && matchesType;
  });

  const sortedItems = [...filteredItems].sort((a, b) => {
    switch (sortBy) {
      case 'price_low': return (a.price || 0) - (b.price || 0);
      case 'price_high': return (b.price || 0) - (a.price || 0);
      case 'name_asc': return (a.name || '').localeCompare(b.name || '');
      case 'name_desc': return (b.name || '').localeCompare(a.name || '');
      default: return 0;
    }
  });

  const handleClick = (product) => {
    setProductDetails(product);
    setActiveItem('PRODUCT');
    window.scrollTo(0, 0);
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className='collection_container'>
      {/* Filter Panel */}
      <div className="collection_filter">
        <h2>FILTERS</h2>
        <div className="collection_type">
          <h3>Product Types</h3>
          {productTypes.map((type) => (
            <label key={type}>
              <input
                type="checkbox"
                value={type}
                checked={selectedTypes.includes(type)}
                onChange={handleTypeChange}
              />
              {type}
            </label>
          ))}
        </div>
        <button 
          className="clear-filters"
          onClick={() => {
            setSelectedTypes([]);
            setSearchQuery('');
            setSortBy('');
          }}
        >
          Clear All Filters
        </button>
      </div>

      {/* Items & Search Area */}
      <div className="collection_list">
        {/* Search Section */}
        <div className="search_section">
          <div className="search_input">
            <input 
              type="text" 
              placeholder='Search products...'
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* Top Filter Bar */}
        <div className="collection_list_top">
          <div className="top_name">
            <h2>All Collections <hr /></h2>
            <p className="results-count">
              {sortedItems.length} {sortedItems.length === 1 ? 'item' : 'items'} found
            </p>
          </div>
          <div className="top_filter">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value="">Sort by</option>
              <option value="price_low">Price: Low to High</option>
              <option value="price_high">Price: High to Low</option>
              <option value="name_asc">Name: A to Z</option>
              <option value="name_desc">Name: Z to A</option>
            </select>
          </div>
        </div>

        {/* Product Grid */}
        <div className="collection_list_bottom">
          <div className="c_list">
            {sortedItems.length > 0 ? (
              sortedItems.map((product) => (
                <div key={product.product_id} className="latest_item" onClick={() => handleClick(product)}>
                  <Item 
                    image={`data:image/jpeg;base64,${product.image}`}
                    name={product.name || ''} 
                    price={product.price || 0}
                    stock={product.stockCount || 0}
                    sizes={product.sizes || []}
                  />
                </div>
              ))
            ) : (
              <div className="no-results">
                <p>No items match your search criteria.</p>
                <button onClick={() => {
                  setSearchQuery('');
                  setSelectedTypes([]);
                  setSortBy('');
                }}>Clear all filters</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collection;
